export const EMAIL_FORM = "EmailForm";
export const PASSWORD_FORM = "PasswordForm";
export const SIGN_UP_FORM = "SignUpForm";
export const COMPLETE_ACCOUNT_FORM = "CompleteAccountForm";
export const SELECT_USER_FORM = "SelectUserForm";
export const FORGOT_PASSWORD_FORM = "ForgotPasswordForm";
export const PRIVATE_NOTICE = "PrivateNotice";
export const TWO_FACTOR_FORM = "TwoFactorForm";
export const TWO_FACTOR_ENROLL_FORM = "TwoFactorEnrollForm";

export const ACCOUNT_DELETED_ERROR_CODE = 403;
